module.exports = __webpack_public_path__ + "img/legende200.f8ab286b.jpg";